import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import { isChildOfParentClass } from 'utilities/dom';

import { DISCARD_TRIM_BUTTON_CLASS } from '../../../../../share-video/control-bar/trim-bar/discard-trim-button';

import './styles.less';

const TRIM_RANGE_MARKER_CLASS_NAME = 'trim-range-marker';

// the number of nested levels in this component when checking if a child click
// happened within
const NUM_PARENT_TRAVERSAL_STEPS = 3;

export const className = 'trim-range-marker-container';

class TrimRangeMarker extends Component {
  render() {
    const { active, selected, style } = this.props;

    const inactiveClass = active ? '' : 'inactive';

    let editMarkerTooltip = null;

    if (selected) {
      editMarkerTooltip = (
        <div
          className="edit-trim-range-tooltip-container"
          onClick={this.props.onEditClick}
        >
          <div className="edit-trim-range-tooltip">
            <p>Edit Trim</p>
          </div>
        </div>
      );
    }

    return (
      <div className={className} style={style}>
        <span
          className={`${TRIM_RANGE_MARKER_CLASS_NAME} ${inactiveClass}`}
          onClick={this.props.onClick}
          // disable seek bar slider
          onMouseDown={this.stopPropagation}
          onMouseMove={this.stopPropagation}
          onMouseUp={this.stopPropagation}
        />
        {editMarkerTooltip}
      </div>
    );
  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  handleClickOutside(e) {
    const { selected } = this.props;

    if (!selected) {
      return;
    }

    // if clicking on another range, let the selected range update without
    // flickering "Discard Trim" from the selected range going to `null` before
    // the update to the new range
    if (e.target.className.includes(TRIM_RANGE_MARKER_CLASS_NAME)) {
      return;
    }

    // a click in the edit marker tooltip will also trigger this click outside
    // handler
    if (
      isChildOfParentClass(
        e.target,
        TRIM_RANGE_MARKER_CLASS_NAME,
        NUM_PARENT_TRAVERSAL_STEPS
      )
    ) {
      return;
    }

    if (
      isChildOfParentClass(
        e.target,
        DISCARD_TRIM_BUTTON_CLASS,
        NUM_PARENT_TRAVERSAL_STEPS
      )
    ) {
      return;
    }

    this.props.onDeselect();
  }
}

export default onClickOutside(TrimRangeMarker);
